import { render, staticRenderFns } from "./hjcx.vue?vue&type=template&id=664c72dc&"
import script from "./hjcx.vue?vue&type=script&lang=js&"
export * from "./hjcx.vue?vue&type=script&lang=js&"
import style0 from "./hjcx.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports